var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BModalForm',_vm._b({ref:"modal",attrs:{"create-default-data":_vm.createDefaultData,"transform-data":_vm.transformData,"save-menu-list":_vm.saveMenuList,"max-width":_vm.hasUsers ? '900px' : '680px'},on:{"closed":function($event){return _vm.$emit('closed')}},scopedSlots:_vm._u([{key:"title-text",fn:function(ref){
var editable = ref.editable;
var viewOnly = ref.viewOnly;
var form = ref.form;
return [_vm._v(" "+_vm._s(_vm.getTitle(editable || viewOnly, form))+" ")]}},{key:"default",fn:function(ref){
var editable = ref.editable;
var viewOnly = ref.viewOnly;
var form = ref.form;
return [_c('PublicationStorageFilesForm',{attrs:{"form":form,"has-users":_vm.hasUsers,"storage":_vm.storage,"disabled":editable || viewOnly,"unzip":_vm.unzip},on:{"update:unzip":function($event){_vm.unzip=$event}}})]}}])},'BModalForm',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }